import { render, staticRenderFns } from "./EditorSectionsManagementTab.vue?vue&type=template&id=4279a0c5"
import script from "./EditorSectionsManagementTab.vue?vue&type=script&lang=ts"
export * from "./EditorSectionsManagementTab.vue?vue&type=script&lang=ts"
import style0 from "./EditorSectionsManagementTab.vue?vue&type=style&index=0&id=4279a0c5&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports